import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FikoSahne } from '../FikoSahne';
import { FikoKaynakca } from '../FikoThreeCam/FikoKaynakca';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor, CommonModule } from '@angular/common';

import { OverlayModule } from '@angular/cdk/overlay';
import { FikoYTService } from '@/src/service/fikoyt.service';
import { FikoDialogService } from '../../../fiko-dialog-core/fiko-dialog.service';

declare var $: any;

@Component({
  selector: 'fikoyt-3d-hizli-menu',
  standalone: true,
  templateUrl: './fiko-3d-hizli-menu.component.html',
  styleUrls: ['./fiko-3d-hizli-menu.component.scss'],
  imports: [CommonModule, FormsModule, OverlayModule]
})
export class Fiko3DHizliMenu implements OnDestroy {
  id_dialog = "Fiko3DHizliMenu" + this.FikoYT.fikoIdUret();
  private modalBaslatildi = false;
  /** */
  miAcik = false;
  // konumlar: any[];
  aktifElement: any;
  aktifSecim: any;
  /** */
  ekleStr: string = "";
  genislik: string = "min-content";

  subsDegisti: Subscription;
  private dialogService = inject(FikoDialogService);

  constructor(
    public readonly FikoYT: FikoYTService,
    public readonly CD: ChangeDetectorRef
  ) {
    this.subsDegisti = FikoYT.degisti.subscribe(() => {
      CD.detectChanges();
    })
  }


  public ac(val?: any, $event?) {
    var _this = this;
    this.aktifElement = val?.object ?? val;
    this.aktifSecim = val;
    this.aktifElement.CD?.detectChanges();
    this.miAcik = true;
    this.CD.detectChanges();

    if (!this.modalBaslatildi) {
      $("#" + this.id_dialog).modal({
        closable: false, duration: 100, allowMultiple: true, detachable: false, keyboardShortcuts: false,
        legacy: false, // 🔧 DRAGGABLE FIX: Semantic UI'nin left: 50% !important uygulayan legacy class'ını engelle
        onShow: () => {
          this.dimmerKaldir(); // 🎯 Güçlendirilmiş dimmer kaldırma
          $("#" + _this.id_dialog).draggable({ handle: ".baslikMove" });
          // z-index'i dialog pencerelerinin üstüne dinamik olarak ayarla
          const zIndex = this.dialogService.overlayZIndexAl();
          $("#" + _this.id_dialog).css('z-index', zIndex);
          $("#" + _this.id_dialog).parent().css('z-index', zIndex);
          this.miAcik = true;
        },
        onHide: () => {
          // Temizlik - menü kapandığında gerekli verileri sıfırla
          this.aktifElement = null;
          this.aktifSecim = null;
          this.miAcik = false;
        }
      });
      this.modalBaslatildi = true;
    }

    // 🎯 FLASH FIX: Modal'ı önce görünmez yap
    const dialogEl = $("#" + this.id_dialog);
    dialogEl.css('opacity', '0');

    $("#" + this.id_dialog).modal('show');

    // 🎯 Pozisyon ayarla ve görünür yap - DOM render olduktan sonra
    setTimeout(() => {
      const zIndex = this.dialogService.overlayZIndexAl();
      dialogEl.css('z-index', zIndex);
      dialogEl.parent().css('z-index', zIndex);
      this.dimmerKaldir();

      // Her zaman clientX/clientY kullan - mini 3D viewer'lar için de doğru pozisyon
      const menuHeight = dialogEl.height() || 0;
      const menuWidth = dialogEl.width() || 0;

      if ($event?.type == "pointerdown") {
        dialogEl.css({
          top: $event.clientY - menuHeight / 2,
          left: $event.clientX - menuWidth / 2
        });
      } else if ($event?.type == "touchstart") {
        dialogEl.css({
          top: $event.touches[0].clientY - menuHeight / 2,
          left: $event.touches[0].clientX - menuWidth / 2
        });
      }

      // 🎯 FLASH FIX: Pozisyon ayarlandıktan sonra görünür yap
      dialogEl.css('opacity', '1');
    }, 10);

    this.CD.detectChanges();
  }

  /**
   * 🎯 DIMMER POINTER-EVENTS FIX
   * Semantic UI modal dimmer'ını kaldırır veya pointer-events'i devre dışı bırakır
   * Bu sayede dialog açıkken 3D canvas üzerinde etkileşim sağlanır
   *
   * ⚠️ KRITIK: Sadece bu menünün parent elementlerine müdahale et
   * Global selector'lar diğer modal/menüleri bozar!
   */
  private dimmerKaldir(): void {
    const dialogEl = $("#" + this.id_dialog);
    const parentEl = dialogEl.parent();

    // 1. Parent'tan dimmer class'ını kaldır
    parentEl.removeClass('dimmer');

    // 🔧 DRAGGABLE FIX: Legacy class'ını kaldır (Semantic UI left: 50% !important sorununu çözer)
    dialogEl.removeClass('legacy');
    parentEl.removeClass('legacy');

    // 2. Sadece bu menünün parent container'ına stil uygula
    // 🔧 DRAGGABLE FIX: Flex centering'i devre dışı bırak
    parentEl.css({
      'pointer-events': 'none',
      'background-color': 'transparent',
      'align-items': 'flex-start',
      'justify-content': 'flex-start'
    });

    // 3. Modal kendisinin pointer-events'ini aktif tut
    // 🔧 DRAGGABLE FIX: margin auto'yu kaldır
    dialogEl.css({
      'pointer-events': 'all',
      'margin': '0'
    });
  }

  /**
   * Menüyü kapat
   * Kapanma kontrolleri FikoSecililer'da yapılır - kapa() çağrılmadan önce kapatmayiEngelle flag'i kontrol edilir
   */
  public kapa() {
    // 🔧 KRITIK FIX: Sadece açıkken kapat
    // dialogKapandi$ eventi HER dialog kapandığında bu metodu çağırır
    // Kapalı bir modal'da modal('hide') çağırmak Semantic UI state'ini bozar
    // ve sonraki açılışlarda modal'ın çalışmamasına neden olur
    if (!this.miAcik && !this.modalBaslatildi) return;

    // Eğer modal başlatılmış ama açık değilse, sadece state'i temizle
    if (!this.miAcik) {
      this.aktifElement = null;
      this.aktifSecim = null;
      return;
    }

    // 🔧 FIX: miAcik'i açıkça false yap - onHide callback'ine güvenme
    // Semantic UI modal state corrupted olabilir, bu durumda callback tetiklenmez
    this.miAcik = false;
    this.aktifElement = null;
    this.aktifSecim = null;
    $("#" + this.id_dialog).modal('hide');
  }

  trackByMenuBaslik(index: number, item: any): string {
    return item?.baslik ?? item?.tipi ?? index;
  }

  ngOnDestroy(): void {
    $("#" + this.id_dialog).remove();
    this.subsDegisti.unsubscribe();
  }
}
